import { SMS_LOCAL_NUMBER_LENGTH } from '../constants/smsOptIn.constants';

const AREA_CODE_LENGTH = 3;
const EXCHANGE_END = 6;

export function toNanpDigits(value: string | null | undefined): string {
    return (value || '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
}

export function isValidNanpLocalNumber(value: string | null | undefined): boolean {
    const digits = toNanpDigits(value);
    if (digits.length !== SMS_LOCAL_NUMBER_LENGTH) return false;

    const areaCode = digits.slice(0, AREA_CODE_LENGTH);
    if (areaCode[0] === '0' || areaCode[0] === '1') return false;
    if (areaCode[1] === '1' && areaCode[2] === '1') return false;

    return true;
}

export function formatNanpLocalNumber(value: string | null | undefined): string {
    const digits = toNanpDigits(value).slice(0, SMS_LOCAL_NUMBER_LENGTH);
    if (digits.length > EXCHANGE_END) {
        return `(${digits.slice(0, AREA_CODE_LENGTH)}) ${digits.slice(AREA_CODE_LENGTH, EXCHANGE_END)}-${digits.slice(EXCHANGE_END)}`;
    }
    if (digits.length > AREA_CODE_LENGTH) {
        return `(${digits.slice(0, AREA_CODE_LENGTH)}) ${digits.slice(AREA_CODE_LENGTH)}`;
    }
    return digits ? `(${digits}` : '';
}

export function toE164(localNumber: string, dialCode: string): string {
    return `+${dialCode}${toNanpDigits(localNumber)}`;
}

export function formatPhoneNumberForDisplay(value: string | null | undefined): string {
    if (!isValidNanpLocalNumber(value)) return value || '';
    return `+1 ${formatNanpLocalNumber(value)}`;
}
